/* RESPONSIBLE TEAM: team-frontend-tech */
import { helper as buildHelper } from '@ember/component/helper';
import URLTruncate from 'embercom/lib/url-truncator';

export default buildHelper(function (params) {
  return URLTruncate(params[0], params[1]);
});
